export default "__VITE_ASSET__BsrqCRYm__"